import { Form } from 'antd';

import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import type { DefaultDiscountMode } from '../_components/RoomDiscount/hooks/useRoomDiscountLogic';

type EffectiveRoomDiscountFormValues = {
  defaultDiscountMode?: DefaultDiscountMode;
  isDefaultDiscountEnabled?: boolean;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
  lastMinuteNightRoomDiscountRate?: number | null;
};

export const resolveEffectiveRoomDiscount = ({
  defaultDiscountMode = 'CONSTANT',
  isDefaultDiscountEnabled,
  defaultNightRoomDiscount,
  defaultNightRoomDiscountDays,
  lastMinuteNightRoomDiscountRate,
}: EffectiveRoomDiscountFormValues): number | undefined => {
  if (isDefaultDiscountEnabled === false) {
    return lastMinuteNightRoomDiscountRate ?? undefined;
  }

  if (defaultDiscountMode === 'DAILY') {
    const dailyValues = Object.values(
      defaultNightRoomDiscountDays ?? {}
    ).filter((value): value is number => value !== null && value !== undefined);

    if (dailyValues.length === 0) {
      return undefined;
    }

    return Math.round(
      dailyValues.reduce((sum, value) => sum + value, 0) / dailyValues.length
    );
  }

  return defaultNightRoomDiscount ?? undefined;
};

export const useEffectiveRoomDiscount = (): number | undefined => {
  const form = Form.useFormInstance<EffectiveRoomDiscountFormValues>();

  return resolveEffectiveRoomDiscount({
    defaultDiscountMode: Form.useWatch('defaultDiscountMode', form),
    isDefaultDiscountEnabled: Form.useWatch('isDefaultDiscountEnabled', form),
    defaultNightRoomDiscount: Form.useWatch('defaultNightRoomDiscount', form),
    defaultNightRoomDiscountDays: Form.useWatch(
      'defaultNightRoomDiscountDays',
      form
    ),
    lastMinuteNightRoomDiscountRate: Form.useWatch(
      'lastMinuteNightRoomDiscountRate',
      form
    ),
  });
};
